import React, { useState, useRef } from "react";
import axios from "axios";
import bannerThumb from "../../assets/images/banner/01.png";
import { animatedImages } from "../../assets/constants/bannerConstants";
import MemberCard from "../../components/items/memberCard";
import { registerationSettings } from "../../assets/constants/signUpConstants";
import { mainURL } from "../../assets/constants/api";
import { Link } from "react-router-dom";

const Banner = () => {
  const [formData, setFormData] = useState({
    gender: "أنثى",
    ageStart: "18",
    ageEnd: "90",
    country: "الكويت",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [members, setMembers] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const resultsRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrorMessage("");
  };

  const handleQuickSearch = async (e) => {
    e.preventDefault();
    const start = parseInt(formData.ageStart);
    const end = parseInt(formData.ageEnd);

    if (start > end) {
      setErrorMessage("عذراً يجب أن يكون العمر إلى أكبر أو يساوي العمر من");
      return;
    }

    setIsLoading(true);
    setErrorMessage("");
    setMembers(null);

    try {
      const payload = {
        age: `${start},${end}`,
        gender: formData.gender,
        country: formData.country,
      };

      const response = await axios.get(
        `${mainURL}/web/members/search-main`,
        {
          params: payload,
        }
      );

      setMembers(response.data.data?.members || []);

      if (response.data.data?.members.length > 0) {
        setTimeout(() => {
          resultsRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    } catch (error) {
      setErrorMessage("حدث خطأ أثناء البحث");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="banner-section">
      <div className="container">
        <div className="section-wrapper">
          <div className="row align-items-end">
            <div className="col-lg-6">
              <div className="banner-content">
                <div className="intro-form">
                  <div className="intro-form-inner">
                    <h3>زواجك مبارك</h3>
                    <p>
                      لكل <strong>آدم حواءه</strong> ابحث مع تطبيق زواجك مبارك
                      عن نصفك الثاني، فإن كان الحب أطهر المشاعر فالزواج أطهرها
                      فعلا....
                    </p>
                    <form onSubmit={handleQuickSearch} className="banner-form">
                      {/* Gender */}
                      <div className="person">
                        <label htmlFor="gender-two" className="left">
                          ابحث عن
                        </label>
                        <div className="custom-select right">
                          <select
                            name="gender"
                            id="gender-two"
                            value={formData.gender}
                            onChange={handleChange}
                          >
                            <option value="ذكر">زوج</option>
                            <option value="أنثى">زوجة</option>
                          </select>
                        </div>
                      </div>

                      {/* Age */}
                      <div className="age">
                        <label htmlFor="age" className="left">
                          العمر
                        </label>
                        <div className="right d-flex justify-content-end gap-1 align-items-center">
                          <label htmlFor="ageStart">من</label>
                          <div className="custom-select">
                            <select
                              name="ageStart"
                              id="ageStart"
                              value={formData.ageStart}
                              onChange={handleChange}
                            >
                              {Array.from({ length: 63 }, (_, i) => 18 + i).map(
                                (age) => (
                                  <option key={age} value={age}>
                                    {age}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          <label htmlFor="ageEnd">إلى</label>
                          <div className="custom-select">
                            <select
                              name="ageEnd"
                              id="ageEnd"
                              value={formData.ageEnd}
                              onChange={handleChange}
                            >
                              {Array.from({ length: 73 }, (_, i) => 18 + i).map(
                                (age) => (
                                  <option key={age} value={age}>
                                    {age}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Country */}
                      <div className="city">
                        <label htmlFor="country" className="left">
                          البلد
                        </label>
                        <div className="custom-select right">
                          <select
                            name="country"
                            id="country"
                            value={formData.country}
                            onChange={handleChange}
                          >
                            {registerationSettings.countries_ar.map((c) => (
                              <option key={c.id} value={c.country_ar}>
                                {c.country_ar}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {members?.length=== 0 ? <div className="text-warning text-center m-3">
                    لا يوجد نتائج
                  </div> : ""}

                      {errorMessage && (
                        <div
                          className="error-message text-danger mt-2"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {errorMessage}
                        </div>
                      )}

                      <button type="submit">ابحث عن شريكك</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="banner-thumb">
                <img src={bannerThumb} alt="banner-thumb" />
              </div>
            </div>
          </div>

          {/* Search Results */}
          <div className="mt-5" ref={resultsRef}>
            {isLoading && (
              <div className="text-center mt-3">
                <div className="spinner-border text-warning" role="status">
                  <span className="visually-hidden">جاري التحميل...</span>
                </div>
              </div>
            )}

            {members && (
              <div className="mt-4">
                {members.length > 0 && (
                  <>
                    <div className="text-center mb-3 text-warning">
                      <small>عدد النتائج: {members.length}</small>
                    </div>
                    <div className="row justify-content-center">
                      {members.map((member, idx) => (
                        <MemberCard key={idx} member={member} />
                      ))}
                    </div>
                    <div className="text-center mt-4">
                      <p className="text-light">
                        هل تريد المزيد من خيارات البحث؟
                        <Link
                          to="/members"
                          className="text-warning text-decoration-underline mx-1"
                        >
                          توجه إلى صفحة الأعضاء
                        </Link>
                      </p>
                    </div>
                  </>
                ) }
                  
                
              </div>
            )}
          </div>
        </div>
      </div>

      {/* animated photos */}
      <div className="all-shapes">
        {animatedImages.map((img, index) => (
          <img
            key={`shape-${index + 1}`}
            src={img}
            alt="shape"
            className={`banner-shape shape-${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Banner;
